"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var window_size_1 = require("@react-hook/window-size");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var logo_svg_1 = __importDefault(require("../../static/svg/logo.svg"));
var icons_1 = require("../../utils/icons");
var MenuFloating_1 = require("../MenuFloating");
var styles_1 = require("./styles");
var widthSizeModifier = 646;
function Header(_a) {
    var withBackground = _a.withBackground;
    var sizeWidth = (0, window_size_1.useWindowWidth)();
    var location = (0, react_router_dom_1.useLocation)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, react_1.useState)(true), isOpenMenu = _b[0], setIsOpenMenu = _b[1];
    var _c = (0, react_1.useState)(false), isOpenMenuSolution = _c[0], setIsOpenMenuSolution = _c[1];
    (0, react_1.useEffect)(function () {
        setIsOpenMenu(false);
    }, [location.pathname]);
    (0, react_1.useEffect)(function () {
        if (isOpenMenu) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'visible';
        }
    }, [isOpenMenu]);
    function handleHome() {
        navigate('/');
    }
    return ((0, jsx_runtime_1.jsxs)(styles_1.ContainerHeader, __assign({ withBackground: withBackground }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.HeaderContainer, { children: [(0, jsx_runtime_1.jsx)("img", { onClick: handleHome, src: logo_svg_1.default }), (0, jsx_runtime_1.jsx)("div", { children: sizeWidth <= widthSizeModifier && ((0, jsx_runtime_1.jsx)(styles_1.ButtonMenu, __assign({ onClick: function () { return setIsOpenMenu(!isOpenMenu); } }, { children: isOpenMenu ? (0, jsx_runtime_1.jsx)(icons_1.IconClose, {}) : (0, jsx_runtime_1.jsx)(icons_1.IconMenu, {}) }))) }), (0, jsx_runtime_1.jsx)(MenuFloating_1.MenuFloating, {})] }), isOpenMenu && sizeWidth <= widthSizeModifier && ((0, jsx_runtime_1.jsx)(styles_1.MenuContainer, __assign({ isMobile: sizeWidth <= widthSizeModifier }, { children: MenuFloating_1.menu.map(function (item) {
                    var _a, _b, _c;
                    if (!!item.path) {
                        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, __assign({ to: item.path }, { children: item.label }), item.label));
                    }
                    return ((0, jsx_runtime_1.jsxs)("a", __assign({ className: "has-group", onClick: function () { return sizeWidth <= widthSizeModifier ? setIsOpenMenuSolution(!isOpenMenuSolution) : {}; } }, { children: [item.label, ' ', (0, jsx_runtime_1.jsx)(icons_1.ChevronRight, { onClick: function () { return setIsOpenMenuSolution(!isOpenMenuSolution); }, className: isOpenMenuSolution ? 'open' : '' }), ((_b = (_a = item === null || item === void 0 ? void 0 : item.group) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 && isOpenMenuSolution && ((0, jsx_runtime_1.jsx)(styles_1.Group, __assign({ className: "group-items" }, { children: (_c = item.group) === null || _c === void 0 ? void 0 : _c.map(function (i) { return ((0, jsx_runtime_1.jsxs)(styles_1.GroupItem, { children: [(0, jsx_runtime_1.jsx)("p", { children: i.label }), (0, jsx_runtime_1.jsx)("ul", { children: i.menu.map(function (m) { return ((0, jsx_runtime_1.jsx)("li", { children: !!(m === null || m === void 0 ? void 0 : m.path) ? ((0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, __assign({ to: m.path }, { children: m.label }))) : (m.label) }, m.label)); }) })] })); }) })))] }), item.label));
                }) })))] })));
}
exports.default = (0, react_1.memo)(Header);
